import React from "react";
import PropTypes from "prop-types";
import SimpleEntitiesSelector from "./simple-entities-selector";
import FormEntitiesSelector from "./form-entities-selector";

const EntitiesSelector = ({ isInsideForm = false, ...props }) =>
  isInsideForm ? <FormEntitiesSelector {...props} /> : <SimpleEntitiesSelector  {...props} />;

EntitiesSelector.propTypes = {
  ...FormEntitiesSelector.propTypes,
  /**
   ** Indica si el componente está dentro de un formulario
   **/
  isInsideForm: PropTypes.bool,
};

export default EntitiesSelector;
